import {
  DropdownMenuTriggerProps,
  Trigger,
} from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

const DropdownToggle: React.FunctionComponent<DropdownMenuTriggerProps> = ({
  children,
  ...props
}) => {
  return (
    <Trigger asChild className={styles.trigger} {...props}>
      {children}
    </Trigger>
  );
};

export default DropdownToggle;
